import React, { FunctionComponent } from 'react';
import { Link } from 'gatsby';
import { InternalLinkIcon } from '../Icons';
import ArticlePreview from '../../component/ArticlePreview';
import { ArticlePreview as ArticlePreviewType } from '../../types/articlePreview';
import './styles.scss';

type RecentArticlesProps = {
  articles: ArticlePreviewType[];
}

const RecentArticles: FunctionComponent<RecentArticlesProps> = ({ articles }) => {
  const articlesList = articles.sort(article => article.highlight ? -1 : 1);

  return (
    <section className='recent-articles bark'>
      <div>
        <div className='recent-articles-header'>
          <div>
            <h2>Our Recent News</h2>
            <p>Everything about peanut</p>
          </div>
          <Link to='/news'>
            <span>Discover more news</span>
            <InternalLinkIcon />
          </Link>
        </div>

        <div className='recent-articles-container'>
          {articlesList.map((article) => (
            <ArticlePreview key={article._id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default RecentArticles;
